<template>
  <SelectTableDialog
    :title="$t('transportDeliveryOrder.msg.copySearchTable')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :confirmUnchecked="false"
    :isMultiple="false"
    :page="true"
    :extraData="extraData"
    :API="productAPI"
    width="1200px"
    @close="close"
    @confirm="confirm"
  ></SelectTableDialog>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  // import BASE_API from '@/api/dataBase.js';
  import SelectTableDialog from '@/components/SelectTableDialog';

  export default {
    components: {
      SelectTableDialog,
    },
    name: 'copySalesLadingbillList',
    data() {
      return {
        defaultVisible: false,
        productAPI: API.GET_DATA_API,
        companyList: [],
        extraData: {
          ladingStatus: 'TDZT07',
          shipComplete: 'Y',
        }, //搜索额外传参
        allotStatusList: [
          { value: 1, label: '已保存' },
          { value: 2, label: '审批中' },
          { value: 3, label: '调拨中' },
          { value: 4, label: '已撤销' },
          { value: 5, label: '调拨完成' },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      searchColumns() {
        return [
          {
            prop: 'ladingNo',
            name: this.$t('transportDeliveryOrder.copySearchTable.ladingNo'),
            placeholder: this.$t('transportDeliveryOrder.copySearchTable.ladingNoPlaceholder'),
            type: 'input',
            maxlength: 30,
          },
          {
            prop: 'customerNo',
            type: 'searchTableSpec',
            isMultiple: true,
            getSearchCode: 'partnerCode',
            name: this.$t('transportDeliveryOrder.copySearchTable.customerName'),
            placeholder: this.$t('transportDeliveryOrder.copySearchTable.customerNamePlaceholder'),
            searchType: 'customer',
          },
          {
            type: 'searchTableSpec',
            prop: 'productNo',
            isMultiple: true,
            getSearchCode: 'productDetailCode',
            name: this.$t('transportDeliveryOrder.copySearchTable.productDesc'),
            placeholder: this.$t('transportDeliveryOrder.copySearchTable.productDescPlaceholder'),
            searchType: 'goodsDetail',
          },
          {
            prop: 'startLadingCreateDate',
            name: this.$t('transportDeliveryOrder.copySearchTable.startLadingCreateDate'),
            placeholder: this.$t(
              'transportDeliveryOrder.copySearchTable.startLadingCreateDatePlaceholder'
            ),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endLadingCreateDate',
            name: this.$t('transportDeliveryOrder.copySearchTable.endLadingCreateDate'),
            placeholder: this.$t(
              'transportDeliveryOrder.copySearchTable.endLadingCreateDatePlaceholder'
            ),
            type: 'endDaterangePicker',
          },
          {
            prop: 'storageNo',
            type: 'searchTableSpec',
            name: this.$t('transportDeliveryOrder.copySearchTable.storageName'),
            placeholder: this.$t('transportDeliveryOrder.copySearchTable.storageNamePlaceholder'),
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
            propCode: 'storageCode',
            propName: 'storageName',
          },
          {
            prop: 'ladingBusinessDepartmentNo',
            name: this.$t('transportDeliveryOrder.copySearchTable.ladingBusinessDepartmentName'),
            placeholder: this.$t(
              'transportDeliveryOrder.copySearchTable.ladingBusinessDepartmentNamePlaceholder'
            ),
            type: 'treeSelect',
            apiUrl: API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            clearable: false,
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'customerName',
            label: this.$t('transportDeliveryOrder.copySearchTable.customerName'),
          },
          {
            prop: 'storageName',
            label: this.$t('transportDeliveryOrder.copySearchTable.storageName'),
          },
          {
            prop: 'ladingBusinessDepartmentName',
            label: this.$t('transportDeliveryOrder.copySearchTable.ladingBusinessDepartmentName'),
          },
          {
            prop: 'ladingNo',
            label: this.$t('transportDeliveryOrder.copySearchTable.ladingNo'),
          },
          {
            prop: 'productDesc',
            label: this.$t('transportDeliveryOrder.copySearchTable.productDesc'),
          },
          {
            prop: 'suppilerName',
            label: this.$t('transportDeliveryOrder.copySearchTable.suppilerName'),
          },
          {
            prop: 'ladingUnitName',
            label: this.$t('transportDeliveryOrder.copySearchTable.ladingUnit'),
          },
          {
            prop: 'ladingQuantity',
            label: this.$t('transportDeliveryOrder.copySearchTable.ladingQuantity'),
          },
          {
            prop: 'remainingQuantity',
            label: this.$t('transportDeliveryOrder.copySearchTable.remainingQuantityOut'),
          },
          {
            prop: 'nameVoyageLicense',
            label: this.$t('transportDeliveryOrder.copySearchTable.nameVoyageLicense'),
          },
          {
            prop: 'ladingCreateDate',
            label: this.$t('transportDeliveryOrder.copySearchTable.ladingCreatDate'),
          },
        ];
      },
    },

    methods: {
      //打开新增页面
      confirm(selections) {
        if (selections.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selections.length > 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.onlyOneSelect'),
            type: 'error',
          });
        } else {
          let path = {
            path: '/logistics/transportDeliveryOrderAdd',
            name: 'transportDeliveryOrderAdd',
            meta: {
              keepAlive: true,
              title: '物流出库单新增',
            },
            query: { flag: 0, no: selections[0].ladingNo, type: 0 }, //type 0:新增
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
              this.defaultVisible = false;
            });
          });
        }
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      /**页面必要代码End */
    },
  };
</script>
